export const COMPANY = {
  legalName: "MĂGUREANU ANDREI-VALENTIN-MIREL ÎNTREPRINDERE INDIVIDUALĂ",
  shortName: "Detecogreen",
  cui: "52769687",
  regCom: "F2025042130009",
  address:
    "București Sectorul 3, Strada Ion Țuculescu, Nr. 42, Bl. P3, Scara C, Etaj 3, Ap. 47",
  city: "București",
  country: "România",
  email: "office@ava-allclean.ro",
  phone: "+40 (732) 873 176",
  phoneRaw: "+40732873176",
  whatsapp: "40732873176",
};
